/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .auth[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;min-height:calc(100vh - 60px);position:relative}[_nghost-%COMP%]   .app-logo[_ngcontent-%COMP%]{position:absolute;top:2%;left:5%}"];
export { styles as styles };
